import { appUpdate } from '@dabble/app';
import { applyUpdate, install, update } from 'offline-plugin/runtime';

export let updateApp = update;

// Export applyUpdate so it can be called when user clicks the update button
export { applyUpdate };

if (location.hostname === 'localhost') {
  updateApp = () => {};
} else {
  install({
    onUpdating() {
      appUpdate.update(update => ({ ...update, state: 'downloading', location: 'web' }));
    },

    onUpdateReady() {
      // Update is downloaded and waiting - show the green button but don't activate yet
      appUpdate.update(update => ({ ...update, state: 'installed', location: 'web' }));
    },

    onUpdated: reloadForUpdate,

    onUpdateFailed(...args) {
      console.log('ServiceWorker Event:', 'onUpdateFailed', args);
    },
  });

  // Reload via controllerchange so every tab refreshes the moment the new SW
  // calls clients.claim(). Reloading earlier races the activate handler's
  // cache cleanup and old chunk URLs fall back to the SPA shell HTML.
  // The first controllerchange on a page that started uncontrolled is the
  // initial SW takeover, not an update, so skip it.
  let skipNextControllerChange = !navigator.serviceWorker?.controller;
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (skipNextControllerChange) {
      skipNextControllerChange = false;
      return;
    }
    reloadForUpdate();
  });

  // Activate any SW that finished installing while the tab was closed.
  navigator.serviceWorker?.ready.then(registration => {
    if (registration.waiting) {
      applyUpdate();
    }
  });
}

let reloading = false;
export function reloadForUpdate() {
  if (reloading) return;
  reloading = true;
  sessionStorage.skipLoadingQuote = 'true';
  window.location.reload();
}
